import React, { Component } from 'react';
import { Modal, Button} from 'react-bootstrap';

export default class EditUser extends Component {  
    handleCallBack = () =>{
      this.props.onCallBack()
      this.props.closeModal()
    }

    render(){
      return(
      <Modal show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-120w"
      size='md'
      aria-labelledby="contained-modal-title-vcenter"
      centered>     
      <Modal.Body>
      {this.props.status === 'INACTIVE' ?
        'You want to Deactivate the User?' :
        'You want to Activate the User Again?'
      }
      </Modal.Body>
      <Modal.Footer>
      <Button onClick={this.handleCallBack}> OK </Button> &nbsp;
      <Button onClick={this.props.closeModal}> Cancel </Button>
      </Modal.Footer>
      </Modal>
      )
    }
    
 
}

  